import { useState } from "react";
import SportsGameStatsModal from "./modals/SportsGameStatsModal.jsx";

const GameStatsButton = ({ gameId, sport, title }) => {
  const [showStats, setShowStats] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-sm btn-primary position-absolute top-0 end-0 m-2 d-flex align-items-center justify-content-center rounded-circle p-0"
        style={{ zIndex: 2, width: 34, height: 34 }}
        aria-label={`View ${title} game statistics`}
        title="Game statistics"
        onClick={() => setShowStats(true)}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M3 3v18h18" />
          <rect x="7" y="13" width="3" height="5" fill="currentColor" stroke="none" />
          <rect x="12" y="9" width="3" height="9" fill="currentColor" stroke="none" />
          <rect x="17" y="6" width="3" height="12" fill="currentColor" stroke="none" />
          <path d="M6 10l5-4 4 2 5-5" />
        </svg>
      </button>
      <SportsGameStatsModal
        show={showStats}
        onClose={() => setShowStats(false)}
        gameId={gameId}
        sport={sport}
        title={title}
      />
    </>
  );
};

export default GameStatsButton;
